export function hamburgerToggle() {
  const headerHamburgerEle = document.querySelector('.js-headerHamburger');
  const headerNavEle = document.querySelector('.js-headerNav');
  const bodyEle = document.querySelector('body');
  const IS_SELECTED = 'is-selected';
  const IS_ACTIVE = 'is-active';
  const IS_VIEW = 'is-view';
  const IS_FIXED = 'is-fixed';

  headerHamburgerEle.addEventListener('click', () => {
    if (headerHamburgerEle.classList.contains(IS_ACTIVE)) {
      bodyEle.classList.remove(IS_FIXED);
      headerNavEle.classList.remove(IS_VIEW);
      headerHamburgerEle.classList.add(IS_SELECTED);
    } else {
      bodyEle.classList.add(IS_FIXED);
      headerNavEle.classList.add(IS_VIEW);
      headerHamburgerEle.classList.remove(IS_SELECTED);
    }

    headerHamburgerEle.classList.toggle(IS_ACTIVE);
  });
}
